__turbopack_context__.v({
  "header-content": "header-content-module-scss-module__hZweRW__header-content",
  "header-content--secondary": "header-content-module-scss-module__hZweRW__header-content--secondary",
  "header-content__controls": "header-content-module-scss-module__hZweRW__header-content__controls",
  "header-content__logo": "header-content-module-scss-module__hZweRW__header-content__logo",
});
